import i18n from "../../../resources/I18n";
import * as MENU_CONFIG from "../../../util/MenuConfig";
import { getMetaTagContent } from "../../../scripts/getMetaTag";
import * as ConstantesAssurabilite from "../../../constants/assurabilite";

export interface IStepIndicatorProps {
  estNouvelleMarge: boolean
}

export function obtenirLibellesStepIndicator(
  props: IStepIndicatorProps,
  i18nLanguage: string
): string {
  const {  estNouvelleMarge } = props;
  const estLangueFrancais = i18nLanguage === 'fr';

  const key = (() => {
    return estNouvelleMarge
      ? 'AMC_VALIDATION_B2_NOUVELLE_MARGE'
      : 'AMC_VALIDATION_B2_CHANGEMENT_LIMITE';
  })();

  return estLangueFrancais ? MENU_CONFIG[`${key}_FR`] : MENU_CONFIG[`${key}_EN`];
}

export default function StepIndicator(props: Readonly<IStepIndicatorProps>) {
  let isApp = getMetaTagContent("oel-is-app") === "true";

  return (
    <dsd-step-indicator
      key={props.estNouvelleMarge ? ConstantesAssurabilite.NOUVELLE : ConstantesAssurabilite.CHANGEMENT}
      substeps-numbering="false"
      steps={obtenirLibellesStepIndicator(props, i18n.language)}
      skip-to-content-id="main-content-title"
      class="dsd-w-100"
      data-testid="step-indicator-validation"
    >
      {!isApp && <span slot="title">{props.estNouvelleMarge ? i18n.t("amc:titre-indicateur-etape-nouvelle-marge"): i18n.t("amc:titre-indicateur-etape-changement-limite")}</span>}
      <span slot="subtitle-mobile">{i18n.t("amc-validation:etape-page-validation-voir-details")}</span>
      <span slot="subtitle">{i18n.t("amc-validation:etape-page-validation-5-de-6")}</span>
    </dsd-step-indicator>
  );
}
